// extracted by mini-css-extract-plugin
export default {"root":"djK0u9iy9JxZQrTLyw8g","iconCross":"fXHqboc_E7993muGsefl","placeHolderShimmer":"y02Trk03HHvJhMgXzxE3"};